<template>

  <div class="mt-2 mb-3">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span class="medium-text">{{ simulationHonoraire.type }}</span>
        <trash-icon class="main-red-color trashIcon ml-2" size="16" @click="removeSimulationHonoraire"/>
        <span v-if="isOperationLinked" class="ml-3 bold-text strongLink" @click="showAddPosteHonoraireModal">
          <template v-if="!hasLinkedOperations">+ {{ $t('simulation.link.poste') }}</template>
          <div v-else class="d-flex align-items-center">
            <div v-for="(text, index) in linkedOperationsText" :key="index" class="d-flex align-items-center">
              <span class="mr-2">{{ text }}</span>
              <span class="text-success mr-3">✓</span>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="row mt-2">

      <div class="col-md-4">
        <b-input-group>
          <b-form-input
              id="prixTTC-input"
              v-model="simulationHonoraire.prixTTC"
              v-disable-scroll
              :placeholder="$t('simulationHonoraire.PrixTTC')"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue">
          </b-form-input>
          <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
        </b-input-group>
      </div>

    </div>

    <add-simulation-poste-honoraire-modal
      ref="addSimulationPosteHonoraireModal"
      :simulation-honoraire="simulationHonoraire"
      :modal-id="'add-simulation-poste-honoraire-modal-' + uniqueId"
      :operation-id="operationId"
      @didAddPosteHonoraire="handleAddPosteHonoraire">
    </add-simulation-poste-honoraire-modal>

  </div>

</template>

<script>

import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import AddSimulationPosteHonoraireModal from './AddSimulationPosteHonoraireModal.vue'
import api from '../../../services/api'

export default {

  name: "SimulationHonoraireComponent",

  components: {
    AutocompleteField,
    AddSimulationPosteHonoraireModal
  },

  props: {
    simulationHonoraire: {
      type: Object,
      default: null
    },
    isOperationLinked: {
      type: Boolean,
      default: false
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  emits: ['removedSimulationHonoraire', 'didChangeValue'],

  computed: {
    uniqueId() {
      return `honoraire-${this.simulationHonoraire.id}`
    },

    linkedOperationsText() {
      if (!this.hasLinkedOperations) return ''

      const countAVP = this.linkedOperationsAVP.length
      const countEXE = this.linkedOperationsEXE.length
      let text = []

      if (countAVP > 0) {
        if (countAVP === 1) {
          text.push(`${this.linkedOperationsAVP[0].name} (AVP)`)
        } else {
          text.push(`${countAVP} postes honoraires (AVP)`)
        }
      }

      if (countEXE > 0) {
        if (countEXE === 1) {
          text.push(`${this.linkedOperationsEXE[0].name} (EXE)`)
        } else {
          text.push(`${countEXE} postes honoraires (EXE)`)
        }
      }

      return text
    }
  },

  data() {
    return {
      hasLinkedOperations: false,
      linkedOperationsAVP: [],
      linkedOperationsEXE: []
    }
  },

  methods: {

    removeSimulationHonoraire() {
      if (!this.simulationHonoraire || !this.simulationHonoraire.id) {
        console.error('Impossible de supprimer : honoraire invalide')
        return
      }

      api
        .post(`/simulationHonoraire/deleteSimulation?id=${this.simulationHonoraire.id}`)
        .then(() => {
          this.$emit('removedSimulationHonoraire', this.simulationHonoraire)
        })
        .catch(error => {
          console.error('Erreur lors de la suppression de l\'honoraire:', error)
          if (error.response) {
            if (error.response.status === 404) {
      this.$emit('removedSimulationHonoraire', this.simulationHonoraire)
            } else if (error.response.status === 401) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          }
        })
    },

    async emitChangeValue() {
      // Sauvegarder la valeur actuelle localement
      const currentValue = this.simulationHonoraire.prixTTC

      // Émettre l'événement de changement
      this.$emit('didChangeValue')

      // Mettre à jour la valeur dans le composant parent
      if (this.simulationHonoraire && this.simulationHonoraire.id) {
        try {



          await api.post(`/simulationHonoraire/${this.simulationHonoraire.id}/updatePrice`, formData)

          // Rafraîchir les données après la mise à jour
          this.loadLinkedOperations()
        } catch (error) {
          console.error('Erreur lors de la mise à jour du prix:', error)
          // Restaurer la valeur en cas d'erreur
          this.simulationHonoraire.prixTTC = currentValue
        }
      }
    },

    showAddPosteHonoraireModal() {
      const modalId = 'add-simulation-poste-honoraire-modal-' + this.uniqueId
      this.$bvModal.show(modalId)
      this.$refs.addSimulationPosteHonoraireModal.show()
    },

    handleAddPosteHonoraire() {
      this.loadLinkedOperations()
    },

    loadLinkedOperations() {
      if (this.operationId && this.simulationHonoraire && this.simulationHonoraire.id) {
        api
          .get(`/simulationHonoraire/getLinkedOperations?simulationHonoraireId=${this.simulationHonoraire.id}`)
          .then(response => {
            console.log('Honoraires liés:', response.data)
            this.linkedOperationsAVP = response.data.honorairesAVP.map(p => ({
              ...p,
              name: p.tostring
            }))
            this.linkedOperationsEXE = response.data.honorairesEXE.map(p => ({
              ...p,
              name: p.tostring
            }))
            this.hasLinkedOperations = this.linkedOperationsAVP.length > 0 || this.linkedOperationsEXE.length > 0
          })
          .catch(error => {
            console.error('Erreur lors de la récupération des honoraires liés:', error)
          })
      }
    }

  },

  watch: {
    simulationHonoraire: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadLinkedOperations()
        }
      }
    }
  },

  mounted() {
    console.log('operationId (component) : ', this.operationId)
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/SimulationHonoraireComponent.vue